module.exports = __webpack_public_path__ + "static/extra_1_mobile-f5239f75570448691d58e01a8bf785a7.jpg";